app.service("OrderEditService", ['$rootScope', function ($rootScope) {

    const service = this;
    const siteHelper = $rootScope.site_helper;

    this.combination_limit = 2;

    this.current_edit_state_model = null;

    const EditStateModel = function () {

        this.edit_solution_cart_models = {};
        this.combination_models = [];
        this.non_manufactured_order_lines = [];
        this.non_manufactured_tally = 0;
        this.any_edit_unavailable = false;
        this.general_edit_unavailable = false;
        this.solution_edit_unavailable = false;
        this.general_edit_state_details = "";
    }

    const CombinationModel = function () {
        this.request_range_id = "";
        this.site_range_id = "";
        this.site_range_choice = null;
        this.style_hidden = false;
        this.order_lines = [];
        this.tally = 0
        this.can_not_edit_order_lines = [];
        this.can_not_edit_tally = 0

        this.initial_colour_id = "";
        this.initial_style_id = "";
        this.initial_colour_choice = null;
        this.initial_style_choice = null;

        this.selected_colour_id = "";
        this.selected_style_id = "";
        this.selected_colour_choice = null;
        this.selected_style_choice = null;

        this.unrelated_cart = [];
    }

    this.EditCartResponseModel = function () {
        this.replacement_cart = [];
        this.matched_replacement_cart = [];
        this.edit_request_in_progress = false;
        this.can_not_apply_to_cart_error = null;
        this.apply_cart_line_errors = [];
        this.original_cart_total = null
        this.edited_cart_total = null
        this.replaced_tally = 0;
        this.can_not_replace_tally = 0;
    }

    this.createEditStateModel = function () {

        const editStateModel = new EditStateModel();

        let orderLines = $rootScope.model.order.current_order ? $rootScope.model.order.current_order.lines : null;

        orderLines = orderLines ? orderLines : [];

        editStateModel.combination_models = [];
        editStateModel.non_manufactured_order_lines = [];
        editStateModel.non_manufactured_tally = 0;

        for (let i = 0; i < orderLines.length; i++) {
            const orderLine = orderLines[i];
            const stateIDs = orderLine.state_ids ? orderLine.state_ids : {}
            const baseComponentID = stateIDs.base_component_id;
            const isCabinetLine = baseComponentID === "solution";
            const isDoorLine = baseComponentID === "door";

            const cacheObject = $rootScope.service.cache_local_server.getComponentObject(baseComponentID, stateIDs.parent_category_group_id, stateIDs.parent_category_id, stateIDs.alpha_category_id, true);
            const isManufactured = !!cacheObject && cacheObject.requires_colour;
            const canEdit = isManufactured && (isCabinetLine || isDoorLine || stateIDs.request_range_id !== 'pronto');
            if (!isManufactured) {
                editStateModel.non_manufactured_order_lines.push(orderLine);
                editStateModel.non_manufactured_tally += orderLine.quantity ? orderLine.quantity : 0;
                continue;
            }

            const requestRangeID = stateIDs.request_range_id ? stateIDs.request_range_id : "";
            const siteRangeID = stateIDs.site_range_id ? stateIDs.site_range_id : "";
            const colourID = stateIDs.colour_id ? stateIDs.colour_id : "";
            const styleID = stateIDs.style_id ? stateIDs.style_id : "";

            if (isCabinetLine && stateIDs.solution_id && !editStateModel.edit_solution_cart_models[stateIDs.solution_id]) {
                const solutionStateIDs = {
                    browse_id: "solution",
                    room_id: stateIDs.solution_id !== "bedroom_flat_pack" ? "kitchen" : "bedroom",
                    solution_id: stateIDs.solution_id,
                    component_id: "solution_cabinet"
                }
                const propertyKeys = ["door_type_id", "site_range_id", "colour_id", "style_id", "edge_option_id", "handle_colour_id", "assembly_id"]
                for (let key in stateIDs) {
                    if (propertyKeys.includes(key)) {
                        solutionStateIDs[key] = stateIDs[key]
                    }
                }
                editStateModel.edit_solution_cart_models[stateIDs.solution_id] = $rootScope.navigation_manager.createNavigationModel(null, solutionStateIDs, true);
            }

            let combinationModel = null;
            for (let i = 0; i < editStateModel.combination_models.length; i++) {
                const checkModel = editStateModel.combination_models [i];
                if (checkModel.site_range_id === siteRangeID && checkModel.initial_colour_id === colourID && checkModel.initial_style_id === styleID) {
                    combinationModel = checkModel;
                    break;
                }
            }
            if (!combinationModel) {
                if (!requestRangeID || !siteRangeID) {
                    continue;
                }

                const siteRangeModel = $rootScope.factory.site_range.getModel();
                const colourModel = $rootScope.factory.colour.getModel({site_range_id: siteRangeID});
                const styleModel = $rootScope.factory.style.getModel({site_range_id: siteRangeID, colour_id: colourID});
                const siteRangeChoice = siteRangeModel.choices[siteRangeID];
                const colourChoice = colourModel.choices[colourID];
                const styleChoice = styleModel.choices[styleID];
                const styleHidden = siteRangeID !== "bella";
                if (!siteRangeChoice || !colourChoice || (!styleChoice && !styleHidden)) {
                    continue
                }


                combinationModel = new CombinationModel();

                combinationModel.request_range_id = requestRangeID;
                combinationModel.site_range_id = siteRangeID;
                combinationModel.site_range_choice = siteRangeChoice;
                combinationModel.style_hidden = styleHidden


                combinationModel.initial_colour_id = colourID;
                combinationModel.initial_style_id = styleID;

                combinationModel.initial_colour_choice = colourChoice;
                combinationModel.initial_style_choice = styleChoice;

                editStateModel.combination_models.push(combinationModel);
            }
            if (canEdit) {
                combinationModel.order_lines.push(orderLine);
                combinationModel.tally += orderLine.quantity ? orderLine.quantity : 0;
            } else {

                combinationModel.can_not_edit_order_lines.push(orderLine);
                combinationModel.can_not_edit_tally += orderLine.quantity ? orderLine.quantity : 0;
            }

        }
        editStateModel.combination_models.sort(function (a, b) {
            if (a.order_lines.length > b.order_lines.length) {
                return -1;
            }
            if (a.order_lines.length < b.order_lines.length) {
                return 1;
            }
            return 0;
        });

        for (let i = 0; i < editStateModel.combination_models.length; i++) {
            const combinationModel = editStateModel.combination_models[i];

            combinationModel.unrelated_cart = editStateModel.non_manufactured_order_lines.slice();

            for (let j = 0; j < editStateModel.combination_models.length; j++) {
                const altCombinationModel = editStateModel.combination_models[j];
                if (j === i) {
                    continue
                }
                combinationModel.unrelated_cart = combinationModel.unrelated_cart.concat(altCombinationModel.order_lines);
                combinationModel.unrelated_cart = combinationModel.unrelated_cart.concat(altCombinationModel.can_not_edit_order_lines);
            }

        }

        if (!editStateModel.combination_models.length) {
            editStateModel.general_edit_unavailable = true;
            editStateModel.general_edit_state_details = "There are no products in your cart that can be replaced.";
        } else if (editStateModel.combination_models.length > service.combination_limit) {
            editStateModel.general_edit_unavailable = true;
            editStateModel.general_edit_state_details = "There are too many product combinations in your cart to use this tool.";
        }

        editStateModel.solution_edit_unavailable = !siteHelper.keyCount(editStateModel.edit_solution_cart_models);
        editStateModel.any_edit_unavailable = editStateModel.general_edit_unavailable && editStateModel.solution_edit_unavailable;

        return editStateModel;
    }

    this.validateReplaceCart = function (originalLines, replacementLines, unaffectedCart, matchedUnaffectedCart, responseModel) {
        responseModel = responseModel ? responseModel : new service.EditCartResponseModel();
        responseModel.replaced_tally = 0;

        for (let i = 0; i < replacementLines.length; i++) {
            responseModel.replaced_tally += replacementLines[i].quantity;
        }

        unaffectedCart = unaffectedCart ? unaffectedCart : [];
        const originalCart = unaffectedCart.slice().concat(originalLines);
        const replacementCart = unaffectedCart.slice().concat(replacementLines);
        const matchedReplacementCart = matchedUnaffectedCart ? matchedUnaffectedCart.slice() : unaffectedCart.slice();
        responseModel.replacement_cart = replacementCart;
        responseModel.matched_replacement_cart = matchedReplacementCart;

        responseModel.edit_request_in_progress = true;

        $rootScope.service.product.addToCart({lines: originalCart}, function (success, messages, firstLine, orderBuild) {
            if (!success) {
                responseModel.can_not_apply_to_cart_error = "We were unable to process your cart";
                responseModel.edit_request_in_progress = false;
                responseModel.replaced_tally = 0;
            } else {
                responseModel.original_cart_total = orderBuild._subtotal_price
                $rootScope.service.product.addToCart({lines: replacementCart}, function (success, messages, firstLine, orderBuild) {
                    if (success) {
                        responseModel.edited_cart_total = orderBuild._subtotal_price
                        responseModel.edit_request_in_progress = false;

                        for (let i = unaffectedCart.length; i < orderBuild.lines.length; i++) {
                            const orderBuildLine = orderBuild.lines[i];
                            matchedReplacementCart.push(orderBuildLine);
                        }
                        return;
                    }
                    let allFailed = !orderBuild || !orderBuild.lines || orderBuild.lines.length !== originalCart.length;
                    if (!allFailed) {
                        allFailed = true;
                        for (let i = unaffectedCart.length; i < orderBuild.lines.length; i++) {
                            const orderBuildLine = orderBuild.lines[i];
                            const errors = $rootScope.service.product.getOrderLineErrors(orderBuildLine);
                            if (errors.length) {
                                responseModel.apply_cart_line_errors.push({
                                    name: orderBuildLine.description,
                                    quantity: orderBuildLine.quantity,
                                    error: errors[0]
                                })
                                replacementCart[i] = originalCart[i];
                                responseModel.replaced_tally -= orderBuildLine.quantity;
                                responseModel.can_not_replace_tally += orderBuildLine.quantity;
                            } else {
                                allFailed = false;
                                matchedReplacementCart.push(orderBuildLine);
                            }
                        }
                    }
                    if (allFailed) {
                        responseModel.can_not_apply_to_cart_error = "We were unable to apply any changes to your cart";
                        responseModel.replaced_tally = 0;
                        responseModel.edit_request_in_progress = false;
                        return;
                    }
                    $rootScope.service.product.addToCart({lines: replacementCart}, function (success, messages, firstLine, orderBuild) {

                        if (success) {
                            responseModel.edited_cart_total = orderBuild._subtotal_price
                        } else {
                            responseModel.can_not_apply_to_cart_error = "There was an error processing your cart";
                            responseModel.replaced_tally = 0;
                        }
                        responseModel.edit_request_in_progress = false;
                    }, true);
                }, true);
            }
        }, true);
        return responseModel;
    }

    this.applyReplacementCart = function (replacementCart, unrelatedCart, responseModel, callback) {
        if (!replacementCart.length) {
            responseModel.can_not_apply_to_cart_error = "Internal error"
            return;
        }
        const currentOrder = JSON.parse(JSON.stringify($rootScope.model.order.current_order));
        const lines = unrelatedCart ? unrelatedCart.slice() : [];
        currentOrder.lines = lines.concat(replacementCart);

        responseModel.edit_request_in_progress = true;
        $rootScope.service.order.saveOrder(currentOrder, function (success, data, messages) {
            responseModel.edit_request_in_progress = false;
            if (!success) {

                responseModel.can_not_apply_to_cart_error = "There was an error replacing your cart" + (messages && messages.length ? ": " + messages[0] : "");
            } else {
                $rootScope.service.tracking.track_event("Cart", "Bulk replaced cart");

                const currentOrder = $rootScope.model.order.current_order;
                const orderLines = currentOrder ? currentOrder.lines : [];
                let reSave = false;
                for (let i = 0; i < orderLines.length; i++) {
                    const line = orderLines[i];
                    if (line._description && line.description && line._description !== line.description) {
                        line.description = line._description;
                        reSave = true;
                    }
                }
                if (reSave) {
                    $rootScope.service.order.saveOrder(currentOrder);
                }

            }
            callback(success);
        });
    }

    $rootScope.$on('current_order_replaced', function ($event, params) {

        $rootScope.navigation_manager.requireInitialized(function () {
            service.current_edit_state_model = service.createEditStateModel();
        });
    })
}]);